import { fromConsignmentItemDetailsResponseV3, toCreateConsignmentItemRequest } from '../models/mapper'
import { ConsignmentItemCreate } from '../models/request'
import { ConsignmentItemDetails } from '../models/types'
import { createConsignmentItemDraftV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createConsignmentItemDraft(data: ConsignmentItemCreate): Promise<ConsignmentItemDetails> {
  const response = await createConsignmentItemDraftV3(toCreateConsignmentItemRequest(data))
  return fromConsignmentItemDetailsResponseV3(response)
}
